/* tslint:disable */
/* eslint-disable */
/**
 * Calvin Risk API
 * TBD
 *
 * The version of the OpenAPI document: 6.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { ConversationalAgentLanguageEnum } from './ConversationalAgentLanguageEnum';
import {
  ConversationalAgentLanguageEnumFromJSON,
  ConversationalAgentLanguageEnumFromJSONTyped,
  ConversationalAgentLanguageEnumToJSON,
} from './ConversationalAgentLanguageEnum';
import type { VoiceAgentInferencerPolymorphic } from './VoiceAgentInferencerPolymorphic';
import {
  VoiceAgentInferencerPolymorphicFromJSON,
  VoiceAgentInferencerPolymorphicFromJSONTyped,
  VoiceAgentInferencerPolymorphicToJSON,
} from './VoiceAgentInferencerPolymorphic';
import type { TaskTypeEnum } from './TaskTypeEnum';
import { TaskTypeEnumFromJSON, TaskTypeEnumFromJSONTyped, TaskTypeEnumToJSON } from './TaskTypeEnum';
import type { VoiceAgentDataset } from './VoiceAgentDataset';
import {
  VoiceAgentDatasetFromJSON,
  VoiceAgentDatasetFromJSONTyped,
  VoiceAgentDatasetToJSON,
} from './VoiceAgentDataset';

/**
 *
 * @export
 * @interface GenerationInputsPolymorphicVoiceAgentGenerationInputs
 */
export interface GenerationInputsPolymorphicVoiceAgentGenerationInputs {
  /**
   *
   * @type {TaskTypeEnum}
   * @memberof GenerationInputsPolymorphicVoiceAgentGenerationInputs
   */
  taskType: TaskTypeEnum;
  /**
   *
   * @type {number}
   * @memberof GenerationInputsPolymorphicVoiceAgentGenerationInputs
   */
  readonly id: number;
  /**
   *
   * @type {ConversationalAgentLanguageEnum}
   * @memberof GenerationInputsPolymorphicVoiceAgentGenerationInputs
   */
  language: ConversationalAgentLanguageEnum;
  /**
   *
   * @type {number}
   * @memberof GenerationInputsPolymorphicVoiceAgentGenerationInputs
   */
  nSamples: number;
  /**
   *
   * @type {VoiceAgentDataset}
   * @memberof GenerationInputsPolymorphicVoiceAgentGenerationInputs
   */
  readonly seedDataset: VoiceAgentDataset;
  /**
   *
   * @type {VoiceAgentInferencerPolymorphic}
   * @memberof GenerationInputsPolymorphicVoiceAgentGenerationInputs
   */
  readonly inferencer: VoiceAgentInferencerPolymorphic;
}

/**
 * Check if a given object implements the GenerationInputsPolymorphicVoiceAgentGenerationInputs interface.
 */
export function instanceOfGenerationInputsPolymorphicVoiceAgentGenerationInputs(
  value: object,
): value is GenerationInputsPolymorphicVoiceAgentGenerationInputs {
  if (!('taskType' in value) || value['taskType'] === undefined) return false;
  if (!('id' in value) || value['id'] === undefined) return false;
  if (!('language' in value) || value['language'] === undefined) return false;
  if (!('nSamples' in value) || value['nSamples'] === undefined) return false;
  if (!('seedDataset' in value) || value['seedDataset'] === undefined) return false;
  if (!('inferencer' in value) || value['inferencer'] === undefined) return false;
  return true;
}

export function GenerationInputsPolymorphicVoiceAgentGenerationInputsFromJSON(
  json: any,
): GenerationInputsPolymorphicVoiceAgentGenerationInputs {
  return GenerationInputsPolymorphicVoiceAgentGenerationInputsFromJSONTyped(json, false);
}

export function GenerationInputsPolymorphicVoiceAgentGenerationInputsFromJSONTyped(
  json: any,
  ignoreDiscriminator: boolean,
): GenerationInputsPolymorphicVoiceAgentGenerationInputs {
  if (json == null) {
    return json;
  }
  return {
    taskType: TaskTypeEnumFromJSON(json['task_type']),
    id: json['id'],
    language: ConversationalAgentLanguageEnumFromJSON(json['language']),
    nSamples: json['n_samples'],
    seedDataset: VoiceAgentDatasetFromJSON(json['seed_dataset']),
    inferencer: VoiceAgentInferencerPolymorphicFromJSON(json['inferencer']),
  };
}

export function GenerationInputsPolymorphicVoiceAgentGenerationInputsToJSON(
  value?: Omit<GenerationInputsPolymorphicVoiceAgentGenerationInputs, 'id' | 'seedDataset' | 'inferencer'> | null,
): any {
  if (value == null) {
    return value;
  }
  return {
    task_type: TaskTypeEnumToJSON(value['taskType']),
    language: ConversationalAgentLanguageEnumToJSON(value['language']),
    n_samples: value['nSamples'],
  };
}
